export const activitiesTypes = {
    views: 'Views',
    notes: 'Notes',
    calls: 'Calls',
    demos: 'Demos',
    emails: 'Emails',
    meetings: 'Meetings',
    cb_changes: 'Startup Updates',
    ratings: 'Ratings',
    users_activity: 'User Activity',
}

export const travelersActivitiesTypes = {
    views: 'Views',
    demos: 'BU Demo',
    meetings: 'EI Due Diligence',
    cb_changes: 'Startup Updates',
    ratings: 'Ratings',
    users_activity: 'User Activity',
}

export const interactionTypes = {
    note: 'Note',
    email: 'Email',
    call: 'Call',
    meeting: 'Meeting',
    demo: 'Demo',
}

export const travelersInteractionTypes = {
    meeting: 'EI Due Diligence',
    demo: 'BU Demo',
}

export const interactionTypesRef = {
    email: 'email',
    call: 'phone_call',
    meeting: 'meeting',
    demo: 'demo',
}
